import Slider from "react-slick";
import ranktracking from "../../Assets/loginSlider/rankTracking.png";
import keywordresrach from "../../Assets/loginSlider/keywordResearch.png";
import backlinks from "../../Assets/loginSlider/backlinksImg.png";

export default function Loginslider() {
  var settings = {
    dots: true,
    infinite: true,
    fade: true,
    arrows: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    accessibility: false,
  };

  const data = [
    {
      title: "Rank Tracking",
      image: ranktracking,
      desc: "Stay ahead in SEO with real-time, accurate rank tracking across search engines.",
    },
    {
      title: "Keyword Research",
      image: keywordresrach,
      desc: "Discover untapped keyword opportunities to drive traffic and dominate your niche.",
    },
    {
      title: "Backlinks",
      image: backlinks,
      desc: "Analyze your link profile to boost authority, fix toxic links, and outsmart competitors.",
    },
  ];

  return (
    <div className="slidermain-div">
      <Slider {...settings}>
        {data?.map((slider) => {
          return (
            <div className="slider" key={slider.title}>
              <img className="slider-img" src={slider.image} />
              <h3 className="title">{slider.title}</h3>
              <p className=" desc text-center">{slider.desc}</p>
            </div>
          );
        })}
      </Slider>
    </div>
  );
}
